/**
 * Shared by SharedRecordSummary and VisitStartIntakeSummary.
 *
 * These moved here when the intake block was pulled out into its own file. They
 * are small enough that copying them would have looked harmless, and `sameNames`
 * is the reason it is not: a version that answers differently for two empty lists
 * decides whether a patient's medication list is suppressed as a duplicate of
 * their chart. Two implementations of that question drifting apart is a clinician
 * reading a different list depending on which screen they opened.
 */

export const hasItems = (arr) => Array.isArray(arr) && arr.length > 0;

export const norm = (v) => String(v ?? '').trim().toLowerCase();

export const joinList = (items) =>
  items.length <= 1
    ? items[0] || ''
    : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;

/** Allergen and medication names, however the two eras of record shape store them. */
export const allergenName = (a) => (typeof a === 'string' ? a : a?.allergen || a?.name);
export const medicationName = (m) => m?.name || m?.medicationName;

/**
 * Do two lists name the same things? Names only — a dose the patient could not
 * remember is not a different medication, and this decides whether one list is a
 * copy of the other, not whether they are equally detailed.
 */
export const sameNames = (a, b) => {
  const left = new Set((a || []).map(norm).filter(Boolean));
  const right = new Set((b || []).map(norm).filter(Boolean));
  if (left.size !== right.size) return false;
  for (const name of left) if (!right.has(name)) return false;
  return true;
};
